import React, { useContext, memo, useMemo, useCallback } from 'react';
import ReactECharts from 'echarts-for-react';
import { stillageTypes } from 'services/stillageDashboard';
import AppContext from 'context/Context';
import { useDispatch } from 'react-redux';
import { openModal } from "slices/stillageWidgetModalSlice";
import PropTypes from 'prop-types';

const TypeChart = ({ data, loading }) => {
    const { config: { isDark } } = useContext(AppContext);
    const dispatch = useDispatch();
    const types = useMemo(() => data, [data]);

    const typeCountsObj = useMemo(() => types?.reduce((acc, item) => {
        const type = item.stillageTypeName;
        acc[type] = [...acc[type] || [], item];
        return acc;
    }, {}), [types]);
    const typeCounts = useMemo(() => Object.entries(typeCountsObj ?? []).map(([name, value]) => (
        {
            name: stillageTypes[name].text,
            value: value?.length,
            itemStyle: {
                color: stillageTypes[name].colour
            },
        })), [typeCountsObj]);

    const handleClick = useCallback(params => {
        const { name } = params;
        const typeKey = Object.keys(stillageTypes).find(key => stillageTypes[key].text === name);
        console.log('Clicked on type:', name, typeKey);
        if (!typeKey) return;
        dispatch(openModal({ title: name, data: typeCountsObj[typeKey] || [], loading }));
    }, [data, typeCountsObj, dispatch, loading]);

    return (
        <ReactECharts
            onEvents={{
                'click': params => handleClick(params)
            }}
            option={{
                title: { show: false },
                legend: {
                    type: 'scroll',
                    show: true,
                    textStyle: {
                        color: isDark ? '#cececeff' : '#000'
                    },
                    itemHeight: 10,
                    itemGap: 6,
                    top: 'middle',
                    left: 0,
                    orient: 'vertical',
                },
                series: [{
                    type: 'pie',
                    name: 'item',
                    itemStyle: {
                        borderRadius: 10,
                        borderWidth: 2
                    },
                    label: {
                        show: false,
                        position: 'center',
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontWeight: 'bold',
                            formatter: '{c}',
                        }
                    },
                    labelLine: {
                        show: false,
                    },
                    radius: ['45%', '90%'],
                    center: ['70%', '50%'],
                    data: typeCounts
                }],
                darkMode: isDark
            }}
            style={{ height: '100%', width: '100%' }}
            showLoading={loading}
        />
    )
}

TypeChart.propTypes = {
    data: PropTypes.array,
    loading: PropTypes.bool
};

export default memo(TypeChart);